import { Avatar as AvatarPrimitive } from 'radix-ui'
import * as React from 'react'
import { cn, initials } from '@/lib/utils'

const palette = [
  'from-violet-500 to-indigo-500',
  'from-cyan-500 to-sky-500',
  'from-fuchsia-500 to-violet-500',
  'from-emerald-500 to-teal-500',
  'from-amber-500 to-orange-500',
  'from-rose-500 to-pink-500',
]

function hash(text: string) {
  let h = 0
  for (let i = 0; i < text.length; i++) h = (h * 31 + text.charCodeAt(i)) | 0
  return Math.abs(h)
}

export function Avatar({
  name,
  src,
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root> & { name: string; src?: string | null }) {
  return (
    <AvatarPrimitive.Root className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)} {...props}>
      {src && <AvatarPrimitive.Image src={src} alt={name} className="aspect-square size-full object-cover" />}
      <AvatarPrimitive.Fallback
        delayMs={src ? 400 : 0}
        className={cn('flex size-full items-center justify-center bg-gradient-to-br text-[0.7em] font-semibold text-white', palette[hash(name) % palette.length])}
      >
        {initials(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  )
}
